angular.module('leanlaw').directive('llClientSummary', ['$timeout', 'autosize', 'alerts', function ($timeout, autosize, alerts) {
  return {
    restrict: 'E',
    template: require("./views/clientSummary.html"),
    scope: {
      client: "=",
      accounting: "=",
      wip: "=",
      me: "=",
      commitChanges: "=?",
      initials: "=?"
    },
    link: function ($scope) {
      $scope.fakeSummary = true;
      $scope.inlineNotesEditMode = false;
      $scope.responsibles = [];
      $scope.canViewTrustAccount = () => {
        const {
          me
        } = $scope;
        return (me.company.settings.trustEnabled || !me.company.settings.hideTrust) && me.permissions.trust.view;
      };
      $scope.showInlineNotesEditor = () => {
        $scope.inlineNotesEditMode = true;
        $timeout(() => {
          const inlineNotesEditor = $('#inlineNotesEditor');
          if (inlineNotesEditor) {
            autosize(inlineNotesEditor);
            inlineNotesEditor.focus();
          }
        }, 200);
      };
      $scope.commitInlineNotesEditing = () => {
        $scope.inlineNotesEditMode = false;
        $scope.commitChanges();
      };
      $scope.copy = async text => {
        if (!navigator || !navigator.clipboard) {
          return;
        }
        await navigator.clipboard.writeText(text);
        alerts.success('Copied to clipboard');
      };
      $scope.cancelInlineNotesEditing = () => {
        $scope.inlineNotesEditMode = false;
      };
      $scope.$watch('client', async client => {
        if (!client) return;
        const {
          matters
        } = client;
        $scope.responsibles = matters ? _.uniq(matters.flatMap(m => m.primary), r => r.id) : [];
      });
    }
  };
}]);